








































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import LeaderboardTeamComponent from '@/components/LeaderboardTeamComponent.vue';                     // @ is an alias to /src
import LeaderboardPlayerComponent from '@/components/LeaderboardPlayerComponent.vue';                 // @ is an alias to /src
import LeaderboardSetComponent from '@/components/LeaderboardSetComponent.vue';                       // @ is an alias to /src
import LeaderboardLockedTeamComponent from '@/components/LeaderboardLockedTeamComponent.vue';                     // @ is an alias to /src
import LeaderboardLockedPlayerComponent from '@/components/LeaderboardLockedPlayerComponent.vue';                 // @ is an alias to /src
import * as utils_tracker from '@/utils_tracker';
import * as utils_topshot from '@/utils_topshot';

export type modeType = 'team' | 'player' | 'set' | 'lockedTeam' | 'lockedPlayer'

@Component({
  name: 'Leaderboards',
  components: { LeaderboardTeamComponent, LeaderboardPlayerComponent, LeaderboardSetComponent, LeaderboardLockedTeamComponent, LeaderboardLockedPlayerComponent }
})

export default class Leaderboards extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public mode: modeType = null

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }

  // private, non-reactive member variables

  @Watch('mode')
  private async modeChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`Leaderboards.modeChanged() ${this.mode}`)

    this.$router.replace(`/leaderboards/${this.mode}`).catch(() => {})
  }

  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`Leaderboards.pathChanged() ${this.$route.path}`)

    // use mode from URL if it exists
    if (this.$route.params.mode) {
      this.mode = this.$route.params.mode as modeType
    } else {
      this.mode = 'lockedTeam'
    }
  }

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    await this.pathChanged()

    this.$router.replace(`/leaderboards/${this.mode}`).catch(() => {})

  }

  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)

  }

}
